import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { SITE_CONFIG } from "@/src/common/constants/site-config";
import { LanguageSwitcher } from "./language-switcher";
import { SiteLogo } from "./site-logo";
import { SocialBrandIcon } from "./social-brand-icon";

export function SiteFooter() {
	const { t } = useTranslation("common");
	const year = new Date().getFullYear();

	return (
		<footer className="border-t border-default-200/60 bg-content1/40">
			<div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
				<div className="grid grid-cols-2 gap-10 md:grid-cols-5">
					<div className="col-span-2 md:col-span-2">
						<SiteLogo />
						<p className="mt-4 max-w-xs text-sm text-default-600">{t("footer.tagline")}</p>
						<div className="mt-6 flex items-center gap-2">
							<a
								href={SITE_CONFIG.socials.linkedin}
								target="_blank"
								rel="noreferrer"
								aria-label="LinkedIn"
								className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-default-200 bg-content1 text-default-600 transition hover:border-default-400 hover:text-foreground"
							>
								<SocialBrandIcon name="linkedin" size={16} />
							</a>
							<a
								href={SITE_CONFIG.socials.x}
								target="_blank"
								rel="noreferrer"
								aria-label="X / Twitter"
								className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-default-200 bg-content1 text-default-600 transition hover:border-default-400 hover:text-foreground"
							>
								<SocialBrandIcon name="x" size={14} />
							</a>
						</div>
					</div>

					{SITE_CONFIG.footerSections.map((section) => (
						<div key={section.titleKey}>
							<h3 className="text-sm font-semibold text-foreground">{t(section.titleKey)}</h3>
							<ul className="mt-4 space-y-3">
								{section.links.map((link) => (
									<li key={link.to}>
										<Link to={link.to} className="text-sm text-default-600 transition hover:text-foreground">
											{t(link.key)}
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				<div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-default-200/60 pt-6 md:flex-row md:items-center">
					<p className="text-xs text-default-500">{t("footer.rights", { year })}</p>
					<LanguageSwitcher />
				</div>
			</div>
		</footer>
	);
}
